import { createMultiStyleConfigHelpers } from "@chakra-ui/styled-system";
import { LogoVariants } from "../Logo.types";
const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(["logo", "logoLetter", "symbol"]);
const baseStyle = {};
const variants = {
    primary: definePartsStyle({
        symbol: {
            fill: "semantic.brand.primary",
        },
    }),
    secondary: definePartsStyle({
        symbol: {
            fill: "semantic.brand.secondary",
        },
    }),
    tertiary: definePartsStyle({
        symbol: {
            fill: "semantic.brand.tertiary",
        },
    }),
    quaternary: definePartsStyle({
        symbol: {
            fill: "semantic.brand.quaternary",
        },
    }),
    quinary: definePartsStyle({
        symbol: {
            fill: "semantic.brand.quinary",
        },
    }),
};
const LogoTheme = defineMultiStyleConfig({
    baseStyle,
    variants,
    defaultProps: {
        variant: LogoVariants.PRIMARY,
        size: "medium",
    },
});
export default LogoTheme;
//# sourceMappingURL=Logo.default.js.map